import { Navigate } from 'react-router-dom';

const AuthGuard = ({ children }) => {
  const isLoggedIn = localStorage.getItem('token'); // or redux/auth context

  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AuthGuard;
